import moment from "moment"

export default (date) => {
    return moment(date).format('HH:mm DD/MM/YYYY')
}